import React, { PureComponent } from 'react';

import { Drag } from 'components/drag';
import DateHelper from 'helpers/Date';
import PropTypes from 'prop-types';

import SubtitleTimelineTimeSection from './SubtitleTimelineTimeSection';

import { SECTION_WIDTH } from '../constants';

class SubtitleTimelineTimeSections extends PureComponent {
  static propTypes = {
    width: PropTypes.number,
    duration: PropTypes.number,
    forwardRef: PropTypes.object,
    onMove: PropTypes.func
  };

  sections = () => {
    const { width, duration } = this.props;

    const countSections = Math.ceil(width / SECTION_WIDTH);
    const sec = duration / countSections;
    const sections = [];
    let diff = 0;

    for (let i = 0; i < countSections; i++) {
      let seconds = 0;

      seconds = sec * i;

      if (i === 0) {
        // eslint-disable-next-line @typescript-eslint/no-magic-numbers
        seconds = sec / 2;
        diff = seconds;
      } else {
        seconds += diff;
      }

      seconds = DateHelper.secondsToHms(Math.floor(seconds));
      sections.push(<SubtitleTimelineTimeSection time={seconds} />);
    }

    return sections;
  };

  render() {
    const { width, forwardRef, onMove } = this.props;

    return (
      <Drag onCueMove={onMove}>
        <div
          ref={forwardRef}
          className="subtitle__timeline__time__sections"
          style={{ width }}
        >
          {this.sections()}
        </div>
      </Drag>
    );
  }
}

const ForwardedInput = React.forwardRef((props, ref) => (
  <SubtitleTimelineTimeSections {...props} forwardRef={ref} />
));

export default ForwardedInput;
